module.exports = __webpack_public_path__ + "static/media/leybold.72031253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leybold.png
// module id = 947
// module chunks = 0